// extracted by mini-css-extract-plugin
module.exports = {"Home":"Login_Home__oktgk","lander":"Login_lander__2A66U"};